<template>
  <div class="i-loader-simple">
    <div class="navbar">
      <iNavbarSimple />
    </div>

    <h2
      v-if="$slots.title"
      class="title"
    >
      <span>
        <slot name="title">Loader Title</slot>
      </span>
    </h2>
    <div
      v-if="$slots.subtitle"
      class="subtitle"
    >
      <span>
        <slot name="subtitle">Loader Subtitle</slot>
      </span>
    </div>
    <div class="animation">
      <iBaseLoadingBar
        :fill-color="brandOpacity100"
        bar-width="100%"
        bar-height="25px"
        :loading-animation-duration-ms="loadingAnimationDurationMs"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { brandOpacity100 } from "@/styles/colors"
import iBaseLoadingBar from "@/components/base/BaseLoadingBar.vue"
import iNavbarSimple from "@/components/global/NavbarSimple.vue"
import { useSlots } from "vue"

// PROPS
defineProps({
  loadingAnimationDurationMs: {
    type: Number,
    default: 4000
  }
})

// SLOTS
useSlots()
</script>

<style scoped lang="scss">
.i-loader-simple {
  z-index: 9998;
  inset: 0;
  position: fixed;

  @include flex(column, center, center, $gap: 12px);

  background-color: $white;
  padding: 12px;

  @media screen and (min-width: $breakpoint-xs) {
    padding: 24px;
  }

  @media screen and (min-width: $breakpoint-sm) {
    padding: 36px;
  }

  @media screen and (min-width: $breakpoint-md) {
    padding: 48px;
  }

  .navbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
  }

  .title {
    @include display-md;

    font-weight: 600;
    margin: 0;
    text-align: center;
  }

  .subtitle {
    @include text-lg;

    font-weight: 400;
    margin: 0 0 12px;
    text-align: center;

    @media screen and (min-width: $breakpoint-lg) {
      display: block;
    }
  }

  .animation {
    width: 100%;
    max-width: 700px;
  }
}
</style>
